import { HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';

import { ConsultorioPrivadoService } from '@/core/api/sicom-api/servicos/pessoa-fisica/consultorio-privado/consultorio-privado.service';
import { ServicoAnexoService } from '@/core/api/sicom-api/servicos/shared/servico-anexo.service';
import type { ConsultorioPrivadoRequest, ConsultorioPrivadoResponse } from '@/core/api/sicom-api/servicos/pessoa-fisica/consultorio-privado/consultorio-privado.model';

@Injectable({ providedIn: 'root' })
export class ConsultorioPrivadoServicosService {
    constructor(
        private api: ConsultorioPrivadoService,
        private servicoAnexo: ServicoAnexoService
    ) {}

    consultar(params: ConsultorioPrivadoRequest, context?: HttpContext): Observable<ConsultorioPrivadoResponse> {
        if (!params?.numeroProtocolo || !params?.anoProtocolo || !params?.ufCrm) {
            return throwError(() => new Error('Parâmetros inválidos: numeroProtocolo, anoProtocolo e ufCrm são obrigatórios.'));
        }

        return this.api.consultar(params, context);
    }

    visualizarAnexo(idAnexo: string, context?: HttpContext): Observable<Blob> {
        const id = idAnexo?.trim();
        if (!id) {
            return throwError(() => new Error('Id do anexo não informado.'));
        }

        return this.servicoAnexo.visualizarAnexo(id, context);
    }
}
